import { Box } from '@mui/material';
import styled from '@mui/system/styled';
import CustomButton from 'components/Button/CustomButton';
import CTypography from 'components/CTypography';

export const ListCnt = styled('div')({
  width: '100%',

  '& .ag-row:last-of-type': {
    boxShadow: 'none',
  },
  '& .ag-header': {
    border: 'none',
    borderRadius: 0,
    marginBottom: 0,
    boxShadow: 'none',
    minHeight: '36px !important',
  },
  '& .ag-header-row': {
    height: '36px !important',
  },
  '& .ag-header-cell': {
    minHeight: '36px',
  },
  '& .ag-header-cell-text': {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.17px',
    color: '#000000DE',
  },
});
